module.exports = __webpack_public_path__ + "img/empty-img.adcccea4.png";